<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row class="ls_action_header">
        <!-- TEXT SEARCH -->
        <Col span="24" style="text-align: center">
          <Input
            placeholder="Введите номер документа"
            style="width: 30%"
            v-model="searchString"
          >
            <Icon type="ios-search" slot="suffix" />
          </Input>
          <!--<FormItem label="Switch">-->
          <span style="margin-left: 20px;"
          >Доп.фильтр
              <i-switch @on-change="toogleFilter" label="Доп.фильтр"></i-switch
              ></span>
          <Button v-if="showClearFilter"
                  @click="clearFilter"
                  type="error"
                  ghost
          >Сбросить фильтр</Button>
        </Col>
      </Row>
      <!-- FILTER -->
      <Row :gutter="10" type="flex" justify="center" v-show="filterShow">
        <Col
        ><Select
          v-model="filter.cash"
          style="width:120px"
          clearable
          placeholder="Касса"
        >
          <Option
            v-for="item in filterOptions.cash"
            :value="item.id"
            :key="item.id"
          >{{ item.name }}
          </Option>
        </Select></Col
        >
        <Col
        ><Select
          v-model="filter.cashier"
          style="width:120px"
          clearable
          placeholder="Кассир"
        >
          <Option
            v-for="item in filterOptions.cashier"
            :value="item.id"
            :key="item.id"
          >{{ item.name }}
          </Option>
        </Select></Col
        >
        <Col
        ><Select
          v-model="filter.store"
          style="width:120px"
          clearable
          placeholder="Магазин"
        >
          <Option
            v-for="item in filterOptions.store"
            :value="item.id"
            :key="item.id"
          >{{ item.name }}
          </Option>
        </Select></Col
        >

        <Col
        ><DatePicker
          v-model="filterOpenDate"
          @on-change="changeFilterOpenDate"
          @on-clear="clearFilterOpenDate"
          format="dd.MM.yyyy"
          type="daterange"
          split-panels
          placeholder="Дата открытия"
          style="width: 200px"
        ></DatePicker></Col>
      </Row>
    </div>
    <!-- DATA TABLE + PAGINATION -->
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>
    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[12, 24, 30]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

    <!-- ITEM VIEW -->
    <shiftItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></shiftItem>
  </div>
</template>
<script>
  import { formatNumber, formatDate, formatDateTime } from "../../base/base_func.js";
import { base_url } from "../../http.js";
import { BaseTableData } from "../../base/base_table.js";
import shiftItem from "@/apps/shift/shiftItem.vue";

let _app = BaseTableData();
_app.components = {
  shiftItem
};

_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/shifts/",
    item_type: "shift",
    loading: true,

    // Table settings
    columns: [
      {
        title: "Смена",
        // width: 340,
        // key: "number",
        // sortable: true,
        render: (h, params) => {
          return h(
            "router-link",
            {
              props: {
                to: {
                  name: this.item_type + "_detail",
                  params: { id: params.row.id }
                }
              }
            },
            `Смена #${params.row.number}`
          );
        }
      },
      {
        title: "Касса",
        // width: 80,
        key: "cash_display",
        sortable: true,
        render: (h, params) => {
          return h(
            "router-link",
            {
              props: {
                to: {
                  name: "cash_detail",
                  params: { id: params.row.cash }
                }
              }
            },
            params.row.cash_display
          );
        }
      },
      {
        title: "Кассир",
        // width: 80,
        key: "cashier_display",
        sortable: true
      },
      {
        title: "Магазин",
        // width: 60,
        key: "store_display",
        sortable: true,
        render: (h, params) => {
          return h(
            "router-link",
            {
              props: {
                to: {
                  name: "store_detail",
                  params: { id: params.row.store }
                }
              }
            },
            params.row.store_display
          );
        }
      },
      {
        title: "Дата открытия",
        key: "open_date",
        sortable: true,
        render: (h, params) => {
          return h(
                  "span",
                  {},
                  formatDateTime(params.row.open_date)
          );
        }
      },
      {
        title: "Дата закрытия",
        key: "close_date",
        sortable: true,
        render: (h, params) => {
          return h(
                  "span",
                  {},
                  formatDateTime(params.row.close_date)
          );
        }
      },
    ],
    data: [],
    lastDraw: 0,
    totalRecords: null,
    currentPage: 1,
    pageSize: 12,
    sorting: "",
    searchString: "",

    filterShow: false,
    filter: {
      store: "",
      cash: "",
      cashier: "",
      open_date__gt: "",
      open_date__lt: "",
    },
    filterOptions: {
      store: [],
      cash: [],
      cashier: [],
    },

    filterOpenDate: ["", ""],
    selected: [],

    item: {
      show: false,
      id: null,
      action: null
    }
  };
};

// Переключения режима "Доп.фильтр"
_app.methods.toogleFilter = function(val){
  this.filterShow = val;

  // Если убираем фильтр - очищаем все поля фильтра
  if (!val) {
    for (let key in this.filter) {
      this.filter[key] = "";
    }

    // Дополнительная очистка фильтров (Даты документа)
    this.filterOpenDate= [];
  } else {
    this.fetchStore();
    this.fetchCash();
    this.fetchCashier();
  }
};


// Очистка фильтров
_app.methods.clearFilter = function(val){
  // Очистка общих фильтров и посика
  if (this.searchString) {
    this.searchString = "";
  }
  for (let key in this.filter) {
    if (this.filter[key]) {
      this.filter[key] = "";
    }
  }

  // Дополнительная очистка фильтров (Даты открытия)
  this.filterOpenDate= [];
};

_app.methods.changeFilterOpenDate = function(date_arr,date_obj){
  if (date_arr[0] && date_arr[1]) {
    this.filter.open_date__gt = this.filterOpenDate[0];
    this.filter.open_date__lt = this.filterOpenDate[1];
  }
};
// Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
_app.methods.clearFilterOpenDate = function(date_arr,date_obj){
  this.filter.open_date__gt = '';
  this.filter.open_date__lt = '';
};

_app.methods.formatNumber = function(number) {
  return formatNumber(number);
};


_app.methods.fetchStore = function(){
  const url = base_url + "/options/stores/";
  this.$http
    .get(url)
    .then(result => {
      this.filterOptions.store = result.data.results;
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка");
    });
};
_app.methods.fetchCash = function(){
  const url = base_url + "/cashes/";
  this.$http
    .get(url)
    .then(result => {
      this.filterOptions.cash = result.data.results;
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка");
    });
};
_app.methods.fetchCashier = function(){
  const url = base_url + "/options/cashiers/";
  this.$http
    .get(url)
    .then(result => {
      this.filterOptions.cashier = result.data.results;
    })
    .catch(error => {
      this.$Message.error("Произошла ошибка");
    });
};


export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/shift/shift.vue